export default __webpack_public_path__ + "static/media/taskAssign.774cb1a8.png";